
import { computed, defineComponent, inject, onMounted, reactive, ref, watchEffect } from 'vue';
import { useStore } from '@/store';
import { months, month_mobiles } from '@/core/data/Month';
import { drivingExperience } from '@/core/data/DrivingExperience';
import { noClaimCertificate } from '@/core/data/NoClaimCertificate';
import BAIDates from '@/core/services/etc/Dates';
import { ElNotification, FormInstance  } from 'element-plus';
import Driver from '@/core/services/car/Drivers';
import { useReCaptcha } from 'vue-recaptcha-v3'
import router from '@/router';
import moment from 'moment';

export default defineComponent({
    setup() {
        // declarations
        const store = useStore();
        const captcha = useReCaptcha();
        
        const message = ref('');
        const ruleFormRef = ref<FormInstance>()
        const month = ref<Array<Object>>(months);
        const month_mobile = ref<Array<Object>>(month_mobiles);
        const drivingExperiences = ref<Array<Object>>(drivingExperience);
        const noClaimCertificates = ref<Array<Object>>(noClaimCertificate);
        const years = ref<Array<number>>();
        const days = ref<Array<number>>();
        const yearDOB = ref<Array<number>>();
        const yearRegisteredYear = ref<Array<number>>();
        const claimed_insurance = ref(false);
        const gcc_specification = ref(false);
        const personal_use = ref(false);
        const current_policy_active = ref<number | Boolean>(false);
        const fully_comprehensive = ref<number | Boolean>(false);

        const isMobile = inject('isMobile')
        const nationality_ids = ref('')
        const country_ids = ref('')
        
        onMounted(() => {

            if(isMobile) {
                const nationality_teleport = document.getElementsByClassName('nationality_teleport')[0]
                nationality_ids.value = nationality_teleport.id

                const country_teleport = document.getElementsByClassName('country_teleport')[0]
                country_ids.value = country_teleport.id
            }

            isClick.value = false
            days.value = BAIDates.getDays();
            years.value = BAIDates.getPolicyStart();
            yearDOB.value = BAIDates.getYearDOB();
            yearRegisteredYear.value = BAIDates.getRegisteredYear(parseInt(customerDetails.value.car_year));
            const value = store.state.drivers.driver;
            claimed_insurance.value = value.claimed_insurance == 2 ? true : false;
            gcc_specification.value = value.gcc_specification == 2 ? true : false;
            personal_use.value = value.personal_use == 2 ? true : false;
            current_policy_active.value = value.current_policy_active == 2 ? true : false;
            fully_comprehensive.value = value.fully_comprehensive == 2 ? true : false;
            if(router.currentRoute.value !== undefined) {
                Driver.setDriverUUID(router.currentRoute.value.query.uuid);
            }
        })

        // computed
        const driver = computed(() => {
            return store.state.drivers.driver;
        });
        const nationalities = computed(() => {
            return store.state.countries.countries;
        })
        const fullscreenLoading = computed(() => {
            return store.state.drivers.loading
        })

        const customerDetails = computed(() => {
            const data = window.localStorage.getItem('customer_detatils');
            return JSON.parse(data || '');
        })

        // rules
        const checkEmpty = (rule: any, value: any, callback: any) => {
            if (!value) {
                callback(new Error('Required'))
            } else {
                callback();
            }
        }

        const checkNationality = (rule: any, value: any, callback: any) => {
            if (!value) {
                callback(new Error(language.value === 'ar' ? 'الرجاء تحديد جنسيتك' : 'Please select your nationality'))
            } else {
                callback();
            }
        }

        const checkFirstCountry = (rule: any, value: any, callback: any) => {
            if (!value) {
                callback(new Error(language.value === 'ar' ? 'الرجاء تحديد الدولة التي أصدرت أول رخصة قيادة لك' : 'Please select country issued your first driving license'));
            } else {
                callback();
            }
        }

        const checkDay = (rule: any, value: any, callback: any) => {
            if (!value) {
                callback(new Error(language.value === 'ar' ? 'الرجاء تحديد اليوم' : 'Please select day'))
            } else {
                callback();
            }
        }

        const checkMonth = (rule: any, value: any, callback: any) => {
            if (!value) {
                callback(new Error(language.value === 'ar' ? 'الرجاء تحديد الشهر' : 'Please select month'))
            } else {
                callback();
            }
        }

        const checkYear = (rule: any, value: any, callback: any) => {
            if (!value) {
                callback(new Error(language.value === 'ar' ? 'الرجاء تحديد السنة' : 'Please select year'))
            } else {
                callback();
            }
        }

        const currentDate = computed(() => {
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        })

        const checkPolicyStartDate = (rule: any, value: any, callback: any) => {
            // if(value < currentDate.value && value !== 'Invalid date') {
            //     callback(new Error(language.value === 'ar' ? 'يجب ألا يكون تاريخ بدء الوثيقة قبل التاريخ الحالي' : 'Policy Start date must not be earlier than the current date'));
            // } else if( driver.value.policy_start_date_month && driver.value.policy_start_date_day && driver.value.policy_start_date_year && driver.value.policy_start_date === 'Invalid date') {
            //     callback(new Error(language.value === 'ar' ? 'الرجاء تحديد تاريخ صحيح لبدء وثيقة التأمين' : 'Please select correct policy start date'));
            // } else {
            //     callback();
            // }
            if(driver.value.policy_start_date === '' || driver.value.policy_start_date === 'Invalid date') {
                callback(new Error(language.value === 'ar' ? 'الرجاء تحديد تاريخ صحيح لبدء وثيقة التأمين' : 'Please select correct policy start date'));
            } else {
                callback();
            }
        }

        const checkFirstRegistrationDate = (rule: any, value: any, callback: any) => {
            if(driver.value.first_registration_date === 'Invalid date' || driver.value.first_registration_date === '' )  {
                callback(new Error(language.value === 'ar' ? 'الرجاء تحديد تاريخ أول تسجيل للسيارة صحيح' : 'Please select correct car first registration date'));
            } else {
                callback();
            }
        }

        const checkdate = computed(() => {
            return dateDif(driver.value.dob)
        })

        const dateDif = (date: any) => {
            date = date.split('-');
            var today = new Date();
            var year = today.getFullYear();
            var month = today.getMonth() + 1;
            var day = today.getDate();
            var yy = parseInt(date[0]);
            var mm = parseInt(date[1]);
            var dd = parseInt(date[2]);
            var years, months, days;
            // months
            months = month - mm;
            if (day < dd) {
                months = months - 1;
            }
            // years
            years = year - yy;
            if (month * 100 + day < mm * 100 + dd) {
                years = years - 1;
                months = months + 12;
            }
            // days
            days = Math.floor((today.getTime() - (new Date(yy + years, mm + months - 1, dd)).getTime()) / (24 * 60 * 60 * 1000));
            //
            // return {years: years, months: months, days: days};
            return years;
        }

        const checkDOB = (rule: any, value: any, callback: any) => {
            // if(checkdate.value < 18 && driver.value.dob_day && driver.value.dob_month && driver.value.dob_year) {
            //     callback(new Error( language.value === 'ar' ? 'تاريخ الميلاد أقل من 18 سنة' : 'Birth Day is less than 18 years old'));
            // } else if (driver.value.dob_day && driver.value.dob_month && driver.value.dob_year && driver.value.dob === 'Invalid date') {
            //     callback(new Error( language.value === 'ar' ? 'الرجاء تحديد تاريخ ميلاد صحيح' : 'Please select correct date of birth'));
            // } else {
            //     callback();
            // }
            if(driver.value.dob === '' || driver.value.dob === 'Invalid date') {
                callback(new Error( language.value === 'ar' ? 'الرجاء تحديد تاريخ ميلاد صحيح' : 'Please select correct date of birth'));
            } else {
                callback();
            }
        }

        const checkHomeCountry = (rule: any, value: any, callback: any) => {
            if(!value) {
                callback(new Error(language.value === 'ar' ? 'الرجاء تسجيل خبرة القيادة في البلد الأم' : 'Please enter home country driving experience'));
            } else {
                callback();
            }
        }

        const checkUAECountry = (rule: any, value: any, callback: any) => {
            if(!value) {
                callback(new Error(language.value === 'ar' ? 'الرجاء تسجيل خبرة القيادة في دولة الإمارات' : 'Please enter UAE country driving experience'));
            } else {
                callback();
            }
        }

        const rules = reactive({
            // dob_month: [{ validator: checkMonth, trigger: ['blur', 'change'] }],
            // dob_day: [{ validator: checkDay, trigger: ['blur', 'change'] }],
            // dob_year: [{ validator: checkYear, trigger: ['blur', 'change'] }],
            dob: [{ validator: checkDOB, trigger: ['blur', 'change'] }],
            nationality: [{ validator: checkNationality, trigger: ['blur', 'change'] }],
            first_driving_license_country: [{ validator: checkFirstCountry, trigger: ['blur', 'change'] }],
            // first_registration_date_year: [{ validator: checkYear, trigger: ['blur', 'change'] }],
            // first_registration_date_day: [{ validator: checkDay, trigger: ['blur', 'change'] }],
            // first_registration_date_month: [{ validator: checkMonth, trigger: ['blur', 'change'] }],
            first_registration_date: [{ validator: checkFirstRegistrationDate, trigger: ['blur', 'change'] }],
            // policy_start_date_day: [{ validator: checkDay, trigger: ['blur', 'change'] }],
            // policy_start_date_month: [{ validator: checkMonth, trigger: ['blur', 'change'] }],
            // policy_start_date_year: [{ validator: checkYear, trigger: ['blur', 'change'] }],
            policy_start_date: [{ validator: checkPolicyStartDate, trigger: ['blur', 'change'] }],
            driving_experience: [{ validator: checkHomeCountry, trigger: ['blur', 'change'] }],
            uae_driving_experience: [{ validator: checkUAECountry, trigger: ['blur', 'change'] }]
        })

        const openError = () => {
            ElNotification({
                title: 'Success',
                message: message.value,
                type: 'error',
            })
        }

        // change event
        const changePolicyExpired = () => {
                driver.value.current_policy_active = current_policy_active.value ? 2 : 1
                driver.value.existing_policy_expired = current_policy_active.value ? 1 : 2;
        }

        const changeThirdPartyLiability = () => {
                driver.value.fully_comprehensive = fully_comprehensive.value ? 2 : 1;
                driver.value.third_party_liability = fully_comprehensive.value ? 1 : 2;
        }
        
        // const dateOfBirth = () => {
        //     if(driver.value != undefined) {
        //         const day = driver.value.dob_day?.toString().length == 1 ? `0${driver.value.dob_day}` : driver.value.dob_day;
        //         const month = driver.value.dob_month?.toString().length == 1 ? `0${driver.value.dob_month}` : driver.value.dob_month;
        //         driver.value.dob = `${driver.value.dob_year}-${month}-${day}`;
        //     }
        // }

        // const carRegistrationDate = () => {
        //     if(driver.value != undefined) {
        //         const day = driver.value.first_registration_date_day?.toString().length == 1 ? `0${driver.value.first_registration_date_day}` : driver.value.first_registration_date_day;
        //         const month = driver.value.first_registration_date_month?.toString().length == 1 ? `0${driver.value.first_registration_date_month}` : driver.value.first_registration_date_month;
        //         driver.value.first_registration_date = `${driver.value.first_registration_date_year}-${month}-${day}`;
        //     }
        // }

        // const policyStartDate = () => {
        //     if(driver.value != undefined) {
        //         const day = driver.value.policy_start_date_day?.toString().length == 1 ? `0${driver.value.policy_start_date_day}` : driver.value.policy_start_date_day;
        //         const month = driver.value.policy_start_date_month?.toString().length == 1 ? `0${driver.value.policy_start_date_month}` : driver.value.policy_start_date_month;
        //         driver.value.policy_start_date = `${driver.value.policy_start_date_year}-${month}-${day}`;
        //     }
        // }

        const selectedNationality = (e: any) => {
            if(driver.value != undefined) {
                nationality_search.value = ''
                driver.value.first_driving_license_country = e
            }
        }

        const changeUaeDrivingExperience = (e: number) => {
            driver.value.uae_driving_experience = e
            resetForm(ruleFormRef.value);
        }

        const changeDrivingExperience = (e: number) => {
            driver.value.driving_experience = e
            resetForm(ruleFormRef.value);
        }

        const handleClaimedInsurance = () => {
            driver.value.claimed_insurance = claimed_insurance.value ? 2 : 1;
            driver.value.claims = claimed_insurance.value ? 0 : 1;
        }

        const handleGccSpecification = () => {
            driver.value.gcc_specification = gcc_specification.value ? 2 : 1;
        }

        const handlePersonalUse = () => {
            driver.value.personal_use = personal_use.value ? 2 : 1;
        }

        // click event
        const handleClick = async (formEl: FormInstance | undefined) => {
            // load captcha
            setUrlValues();
            isClick.value = true
            await captcha?.recaptchaLoaded()
            
            // driver.value.dob  = moment(driver.value.dob).format('YYYY-MM-DD');
            // driver.value.first_registration_date  = moment(driver.value.first_registration_date).format('YYYY-MM-DD');
            // driver.value.policy_start_date  = moment(driver.value.policy_start_date).format('YYYY-MM-DD');
            // execute reCaptcha
            const token = await captcha?.executeRecaptcha('login');
            // console.log(token);
            
            if (!formEl) return
                formEl.validate(async(valid, fields: any) => {
                    if (valid) {
                        if(token) {
                            Driver.setDriverUUID(driver.value.uuid.replace('null', ''))
                            await Driver.postDriverDetails(driver.value);
                            isClick.value = false
                        } else {
                            message.value = 'Captcha Error';
                            openError();
                            isClick.value = false
                        }
                        // console.log('success')
                    } else {
                        // message.value = 'Some Field/s are missing';
                        // openError();
                        currentField(Object.keys(fields)[0])
                        isClick.value = false
                        return false
                    }
                })
            }

        const setUrlValues = () => {
            driver.value.sid = router.currentRoute.value.query && router.currentRoute.value.query.sid ?  router.currentRoute.value.query.sid.toString() : '';
        }

        const dob = ref<HTMLElement>();
        const nation = ref<HTMLElement>();
        const country = ref<HTMLElement>();
        const first_reg = ref<HTMLElement>();
        const policy_start = ref<HTMLElement>();

        const currentField = (e: any) => {
            if(e == 'dob_day' || e == 'dob_month' || e == 'dob_year' || e == 'dob') {
                window.scrollTo(0, 0);
            }

            if(e == 'nationality') {
                window.scrollTo(0, 160);

            }

            if(e == 'first_driving_license_country') {
                window.scrollTo(0, 320);

            }

            if(e == 'first_registration_date' || e == 'first_registration_date_day' || e == 'first_registration_date_month' || e  == 'first_registration_date_year') {
                window.scrollTo(0, 480);
            }
            
            if(e == 'policy_start_date_day' || e == 'policy_start_date_month' || e  == 'policy_start_date_year' || e == 'policy_start_date') {
                window.scrollTo(0, 720);

            }

            if(e == 'driving_experience') {
                window.scrollTo(0, 720);

            }

            if(e == 'uae_driving_experience') {
                window.scrollTo(0, 800);

            }
        }

        const isClick = ref(false)

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return
            formEl.clearValidate()
        }

        // watchEffect(() => {
        //     driver.value.dob  = moment(driver.value.dob).format('YYYY-MM-DD');
        //     driver.value.first_registration_date  = moment(driver.value.first_registration_date).format('YYYY-MM-DD');
        //     driver.value.policy_start_date  = moment(driver.value.policy_start_date).format('YYYY-MM-DD');
        // })

        const language = computed(() => {
            return window.localStorage.getItem('language');
        })

        const dobMaxDate = computed(() => {
            return moment().subtract(18, 'years')
        })

        const firstRegistrationMinDate = computed(() => {
            return moment().year(customerDetails.value.car_year).subtract(3, 'years')
        })

        const firstRegistrationMaxDate = computed(() => {

            return moment().year(customerDetails.value.car_year).add(1, 'year')
        })

        const todayDate = computed(() => {
            return moment().subtract(1, 'day')
        })

        const policyStartMaxDate = computed(() => {
            return moment().add(1, 'year')
        })

        const nationality_search = ref('')
        const country_search = ref('')

        const filtered_nationality = computed(() => {
            if(nationalities.value) {
                return nationalities.value.filter(obj => 
                obj.label.toString().toLowerCase().includes(nationality_search.value.toLowerCase())
                );
            }
        })

        const filtered_country = computed(() => {
            if(nationalities.value) {
                return nationalities.value.filter(obj => 
                obj.label.toString().toLowerCase().includes(country_search.value.toLowerCase())
                );
            }
        })

        const nationality_search_ref = ref()
        const country_search_ref = ref()

        const alertNationality = () => {
            setTimeout(() => {
                // nationality_search_ref.value.focus()
            }, 500);
        }

        const alertCountry = () => {
            setTimeout(() => {
                // country_search_ref.value.focus()
            }, 500);
        }

        return {
            nationality_search_ref,
            country_search_ref,
            alertNationality,
            alertCountry,
            isMobile,
            nationality_ids,
            country_ids,
            nationality_search,
            country_search,
            filtered_nationality,
            filtered_country,
            dobMaxDate,
            todayDate,
            policyStartMaxDate,
            firstRegistrationMaxDate,
            firstRegistrationMinDate,
            language,
            resetForm,
            checkdate,
            isClick,
            currentDate,
            customerDetails,
            yearDOB,
            yearRegisteredYear,
            dob,
            nation,
            country,
            first_reg,
            policy_start,
            message,
            captcha,
            driver,
            nationalities,
            rules,
            month,
            month_mobile,
            years,
            days,
            drivingExperiences,
            noClaimCertificates,
            ruleFormRef,
            changePolicyExpired,
            changeThirdPartyLiability,
            // dateOfBirth,
            // carRegistrationDate,
            // policyStartDate,
            handleClick,
            selectedNationality,
            changeUaeDrivingExperience,
            changeDrivingExperience,
            handleClaimedInsurance,
            handleGccSpecification,
            handlePersonalUse,
            claimed_insurance,
            gcc_specification,
            personal_use,
            current_policy_active,
            fully_comprehensive,
            fullscreenLoading
        }
    },
})
